class BogofAdd extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.bogof-card__add');
    this.initialiseBogofAdd();
  }

  initialiseBogofAdd() {
    this.trigger.addEventListener('click', () => {
      this.handleClick();
    });
  }

  handleClick() {
    
    const selectedVariant = parseInt(this.querySelector('.bogof-card__select').value)

    window.BAO.Cart.addItem({ id: selectedVariant, properties: null }, null, {
      sections: window.BAO.utils.sectionRenderer.pushCartSections.map(
        s => s.section,
      ),
    })
  }


}

customElements.define('bogof-add', BogofAdd);